const INDEX_ITEMS = [
  { title: '动作冒险', desc: '热血战斗与惊险冒险，韩国漫画最具代表性的题材之一', count: '86部', icon: 'ri-sword-line' },
  { title: '奇幻世界', desc: '异世界转生、剑与魔法，韩国奇幻漫画的想象力无边界', count: '124部', icon: 'ri-magic-line' },
  { title: '浪漫爱情', desc: '细腻动人的情感描绘，韩国浪漫漫画的独特魅力', count: '97部', icon: 'ri-heart-line' },
  { title: '悬疑推理', desc: '烧脑剧情与反转不断，韩国悬疑漫画让人欲罢不能', count: '53部', icon: 'ri-search-eye-line' },
  { title: '搞笑日常', desc: '轻松幽默的校园与职场故事，解压治愈的首选', count: '68部', icon: 'ri-emotion-laugh-line' },
  { title: '恐怖惊悚', desc: '令人毛骨悚然的韩国恐怖漫画，胆大者的深夜读物', count: '41部', icon: 'ri-ghost-line' },
  { title: '历史架空', desc: '以韩国历史为背景的架空故事，兼具深度与娱乐性', count: '35部', icon: 'ri-ancient-gate-line' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          主题索引
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          按题材分类浏览，快速找到您感兴趣的韩国漫画类型
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group bg-background-50 rounded-xl p-5 text-center cursor-pointer hover:scale-[1.03] transition-all duration-300"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100/70 flex items-center justify-center group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-2 line-clamp-2">
                {item.desc}
              </p>
              <span className="text-xs text-primary-600 font-medium">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}